import app from 'flarum/common/app';
import User from 'flarum/common/models/User';
import { avatarsUrl } from '../util';

User.prototype.avatarUrl = function() {
  return `${avatarsUrl}/${this.data.id}.jpg`;
};

app.initializers.add('speareducation/flarum', () => {

});
